import { useMemo } from 'react';
import { usePreparedSource } from '../../data';
import { checkHeaderAvailability } from '../../utils';

export function useHeaderData() {
  const { preparedSources, sourcesReady } = usePreparedSource();

  const isReady = useMemo(() => {
    if (!sourcesReady) {
      return false;
    }

    return checkHeaderAvailability(preparedSources);
  }, [sourcesReady, preparedSources]);

  return useMemo(() => {
    if (!isReady) {
      return {};
    }

    const [source] = preparedSources;

    return source?.author ?? {};
  }, [isReady, preparedSources]);
}
